export const providerDegrees = [
  {
    id: 1,
    name: 'APRN',
    description: 'Advanced practice registered nurse',
    createdAt: '2019-09-09T20:47:40.494Z',
    updatedAt: '2022-05-11T09:38:35.841Z',
    createdBy: null,
    updatedBy: 1,
  },
  {
    id: 10,
    name: 'BA',
    description: null,
    createdAt: '2019-09-09T20:47:40.494Z',
    updatedAt: '2019-09-09T20:47:40.494Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 2,
    name: 'BS',
    description: null,
    createdAt: '2019-09-09T20:47:40.494Z',
    updatedAt: '2019-09-09T20:47:40.494Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 3,
    name: 'BSN',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2022-04-06T14:07:03.260Z',
    createdBy: null,
    updatedBy: 1,
  },
  {
    id: 6,
    name: 'CDE',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 81,
    name: 'CNM',
    description: 'st',
    createdAt: '2020-07-16T00:30:08.112Z',
    updatedAt: '2022-06-10T07:45:50.774Z',
    createdBy: null,
    updatedBy: 1,
  },
  {
    id: 9,
    name: 'CNOR',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 5,
    name: 'CNS',
    description: 'Clinical nurse specialist',
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2021-04-15T23:55:41.711Z',
    createdBy: null,
    updatedBy: 1,
  },
  {
    id: 84,
    name: 'CRNA',
    description: 'Certified Registered Nurse Anesthetist',
    createdAt: '2021-04-15T23:58:34.785Z',
    updatedAt: '2021-04-15T23:59:51.163Z',
    createdBy: 1,
    updatedBy: 1,
  },
  {
    id: 7,
    name: 'CRNP',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 8,
    name: 'DNP',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 11,
    name: 'DO',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 12,
    name: 'DrPH',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 13,
    name: 'EdD',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 14,
    name: 'FACS',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 15,
    name: 'FASMBS',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 16,
    name: 'FTOS',
    description: null,
    createdAt: '2019-09-09T20:47:40.495Z',
    updatedAt: '2019-09-09T20:47:40.495Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 17,
    name: 'LCSW/LSW',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 18,
    name: 'LD',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 19,
    name: 'LPC',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 20,
    name: 'LPN',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 21,
    name: 'MA',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 22,
    name: 'MBA',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 23,
    name: 'MBBS',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 24,
    name: 'MD',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 25,
    name: 'MD/PhD',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 26,
    name: 'MEd',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 27,
    name: 'MPH',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 28,
    name: 'MS',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 29,
    name: 'MSN',
    description: null,
    createdAt: '2019-09-09T20:47:40.496Z',
    updatedAt: '2019-09-09T20:47:40.496Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 30,
    name: 'MSW',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2019-09-09T20:47:40.497Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 31,
    name: 'NP',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2019-09-09T20:47:40.497Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 82,
    name: 'NSN',
    description: 'NSN',
    createdAt: '2020-07-17T20:37:13.031Z',
    updatedAt: '2020-07-17T20:37:13.031Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 32,
    name: 'PA',
    description: "Physician's Assistant",
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2021-04-15T23:58:59.775Z',
    createdBy: null,
    updatedBy: 1,
  },
  {
    id: 33,
    name: 'PharmD/RPh',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2019-09-09T20:47:40.497Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 34,
    name: 'PhD',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2019-09-09T20:47:40.497Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 35,
    name: 'Post Doc',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2019-09-09T20:47:40.497Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 36,
    name: 'PsyD',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2019-09-09T20:47:40.497Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 37,
    name: 'RD',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2019-09-09T20:47:40.497Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 38,
    name: 'RN',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2019-09-09T20:47:40.497Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 39,
    name: 'ScD',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2019-09-09T20:47:40.497Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 40,
    name: 'Student',
    description: null,
    createdAt: '2019-09-09T20:47:40.497Z',
    updatedAt: '2022-02-09T08:45:00.943Z',
    createdBy: null,
    updatedBy: 1,
  },
];
